const getApiBase = () => {
  if (process.env.REACT_APP_BACKEND_URL) return process.env.REACT_APP_BACKEND_URL;
  if (typeof window === 'undefined') return '';

  const hostname = window.location.hostname;
  if (['oneglobealliance.com', 'www.oneglobealliance.com', 'uat.oneglobealliance.com', 'kyc.boltcargo.com'].includes(hostname)) {
    return window.location.origin;
  }
  return 'http://localhost:8001';
};

const API_BASE = getApiBase();

export const getProfilePictureUrl = (profile) => {
  const value = profile?.profile_picture;
  if (!value || typeof value !== 'string') return '';
  if (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('data:')) {
    return value;
  }
  return `${API_BASE}${value}`;
};

export const getProfilePictureOrInitials = (profile, displayName = 'Member') => {
  return getProfilePictureUrl(profile)
    || `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(displayName)}`;
};
